import {
  AutomatedReviewThreadComment,
  type AutomatedReviewThreadCommentProps,
  // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
} from '@github-ui/diff-lines/automated-review-thread-comment'

export interface AutomatedReviewCommentProps extends Omit<AutomatedReviewThreadCommentProps, 'isClassicExperience'> {}

/**
 * React partial wrapper for AutomatedReviewThreadComment used by the Rails classic experience.
 *
 * This component is rendered via Rails react partials for the classic PR views (Conversations tab
 * and classic Files Changed). Since the partial is always used in the classic experience context,
 * isClassicExperience is hardcoded to true here rather than passed from the backend.
 *
 * The new React Files Changed experience renders AutomatedReviewThreadComment directly
 * (without isClassicExperience) via ReviewThread.tsx.
 *
 * NOTE: As of the time of this writing, the Conversations tab uses a Rails partial to render
 * automated review comments, even though the React Conversations experience is enabled.
 * If the Conversations tab ever migrates to render this component via React (rather than Rails),
 * special handling may be needed for features like the batch suggestions button that are only
 * available in the Files Changed experience.
 */
export function AutomatedReviewComment(props: AutomatedReviewCommentProps) {
  return <AutomatedReviewThreadComment {...props} isClassicExperience />
}
